import React, {useState, useEffect} from 'react'
import {withRouter} from 'react-router-dom'
import ARTUpload from '../../components/ART'
import ARTLogs from '../../components/ART/logs'
import PageShell from '../../components/UI/PageShell'
const ART = ()=>{
    return (
                <PageShell title="ART Results" eyebrow="Health records" description="Upload and review your ART test records.">
                  <div className="portal-content-card">
                    <ARTUpload />
                    <ARTLogs />
                  </div>
                </PageShell>
              )
    }
    export default withRouter(ART) 
